import { render, staticRenderFns } from "./SideOverlay.vue?vue&type=template&id=16af7816&scoped=true&"
import script from "./SideOverlay.vue?vue&type=script&lang=js&"
export * from "./SideOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af7816",
  null
  
)

export default component.exports